import React from 'react';
import DestinationGlobe from './DestinationGlobe';
import './RsvpHero.css';

export default function RsvpHero() {
  return (
    <section className="hero">
      <p className="hero__flight">
        <span>FLT 2026</span>
        <span className="hero__sep">·</span>
        <span>MAY 4</span>
        <span className="hero__sep">·</span>
        <span>18:00 CST</span>
      </p>

      <h1 className="hero__title">
        <span className="hero__title-line">Destination:</span>
        <span className="hero__title-line hero__title-line--accent">Success</span>
      </h1>

      <div className="hero__body">
        <div className="hero__body-text">
          <p className="hero__sub">
            <span>VMHS Career &amp; Technical Education</span>
            <span className="hero__sub-sep">·</span>
            <span>Class of 2026</span>
          </p>

          <dl className="hero__manifest">
            <div className="hero__manifest-row">
              <dt>Departure</dt>
              <dd>Mon · May 4, 2026 · 6:00 PM</dd>
            </div>
            <div className="hero__manifest-row">
              <dt>Terminal</dt>
              <dd>VMHS Auditorium · 7618 Evans Rd, San Antonio</dd>
            </div>
            <div className="hero__manifest-row">
              <dt>Reception</dt>
              <dd>Following the ceremony, in the cafeteria</dd>
            </div>
            <div className="hero__manifest-row">
              <dt>Dress</dt>
              <dd>Semi-formal</dd>
            </div>
          </dl>
        </div>

        <div className="hero__body-globe" aria-hidden="true">
          <DestinationGlobe size={260} />
        </div>
      </div>
    </section>
  );
}
